import request from '../utils/request';
import axios from 'axios';
export const uploadFile = async (file: File) => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const res = await request({
        method: 'post',
        url: '/common/uploadFile',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (res.success && res.data?.url) {
        return res.data.url;
      } else {
        throw new Error(res.message || 'Upload failed');
      }
    } catch (error) {
      console.error('Upload error:', error);
      throw error;
    }
  };
 

  export const generateRandomCode = () => {
    const now = new Date();
    const year = now.getFullYear().toString().slice(-2); // 获取年份后两位
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份，补零
    const day = now.getDate().toString().padStart(2, '0'); // 日期，补零
    
    const datePart = `${year}${month}${day}`; // 例如: 250807
    
    // 生成8位随机数字
    const randomPart = Math.random().toString().slice(2, 10); // 取8位数字
    
    const fullCode = `${datePart}${randomPart}`; // 例如: 25080712345678
    // 将完整代码转换为36进制（0-9和A-Z）
    const base36Code = parseInt(fullCode).toString(36).toUpperCase();
    
    return base36Code;
  };
 


// 获取上传签名
export const getUploadsign = async (params: any) => {
  return request({
    url: '/upload/getSign',
    data: params,
    method: 'post',
  });
};

// 上传图片到OSS
export const uploadImageToOss = async (host: string, fd: FormData) => {
  return axios.request({
    url: host,
    data: fd,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
 
// 上传图片到OSS
async function uploadNewImg(data: any, storeAs: string, file: File, uploadImageToOssFunc: typeof uploadImageToOss) {
 
  let host = data["host"];
  let policyBase64 = data["policy"];
  let accessid = data["accessid"];
  let signature = data["signature"];
  // let expire = parseInt(data['expire'])
  // let callbackbody = data['callback']
  let key = data["dir"];

  let storeAsKey = key + storeAs;
  console.log('storeAsKey', storeAsKey);
  // 正确构建FormData
  let fd = new FormData();
  fd.append('key', storeAsKey);
  fd.append('policy', policyBase64);
  fd.append('OSSAccessKeyId', accessid);
  fd.append('success_action_status', '200');
  fd.append('signature', signature);
  fd.append('file', file);
  
  return new Promise((resolve, reject) => {
    uploadImageToOssFunc(host, fd).then((res: any) => {
      resolve(storeAsKey);
    }).catch((error: any) => {
      reject(error);
    });
  });
} 


export async function baseImageToOss(filename: string, baseimage: string, bucket: string) {
 
  var base64ToBlob = function (filename: string) {
    let parts = filename.split(";base64,");
    let contentType = parts[0].split(":")[1];
    let raw = window.atob(parts[1]);
    let rawLength = raw.length;
    let uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], {
      type: contentType,
    });
  };
  
  // 生成随机计数
  // const count = Math.floor(Math.random() * 10000);
  let name = filename.slice(0, 2) + "/" + filename;
  let blob = base64ToBlob(baseimage);
  
  // 将 Blob 转换为 File
  const file = new File([blob], name, { type: blob.type });
  
  let res = await getUploadsign({ md5file: name, bucket: bucket });
  if (res.result) {
    await uploadNewImg(res.result, name, file, uploadImageToOss);
  }
  return name;
}
